import React, { useEffect, useMemo, useState } from "react";
import {
  Button,
  Typography,
  Box,
  CircularProgress,
  Chip,
  Tooltip,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import ActivityMenuModal from "../../Modals/ActivityMenuModal";
import ViewActivityMenuModal from "../../Modals/ViewActivityModal";
import {
  createActivitiesBySiteId,
  getActivitiesBySiteId,
  getStageMaster,
} from "../../services/siteServices/subSiteService";
import { useParams } from "react-router-dom";
import {
  getAssignee,
  reInitiateActivity,
  updateActivityDetails,
} from "../../services/ActivityDetailsService/ActivityDetailsService";
import {
  convertToISOFormat,
  getChangedData,
  getCurrentDate,
  getStatusColor,
} from "../../helpers/utils";
import { getActivityHistoryByID } from "../../services/ActivityHistoryService/ActivityHistoryService";
import AutoModeIcon from "@mui/icons-material/AutoMode";
import AlertModal from "../../Modals/AlertModal";
import SnackBars from "../snackbars/SnackBars";
import RunningWithErrorsIcon from "@mui/icons-material/RunningWithErrors";
import {
  downloadAttachment,
  getAllAttachmentCategory,
  getAllStatusesAndRemarks,
  getSpecificRemarkCategoryForActivity,
  tagUploadedAttachment,
} from "../../services/AttachmentService/AttachmentService";
import DynamicTable from "./DynamicTable";

const ActivityTable = ({
  activities,
  setActivities,
  get_Site,
  setTrigger,
  projectCode,
  projectId,
  partner,
}) => {
  const { id } = useParams();
  const [auditData, setAuditData] = useState([]);
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [editedActivity, setEditedActivity] = useState(null);
  const [selectedSubActivity, setSelectedSubActivity] = useState(null);
  const [initialSelectedSubActivity, setInitialSelectedSubActivity] =
    useState(null);
  const [activityHistory, setActivityHistory] = useState([]);
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);
  const [errors, setErrors] = useState({
    remarkCategory: false,
    remarkStatement: false,
    actualEndDate: false,
    startDare: false,
    attachments: false,
  });
  const [isLoading, setIsLoading] = useState(false);
  const [formValues, setFormValues] = useState({
    modalTitle: "",
    startDate: getCurrentDate(),
    expectedEndDate: "",
    actualEndDate: "",
    assignedTo: "",
    status: "Started",
    remarkCategory: "",
    tenderStatus: 0,
    remarkStatement: "",
    attachments: [],
  });

  const [reInitiateModal, setReInitiateModal] = useState(false);
  const [selectedReInitiatedItem, setSelectedReInitiatedItem] = useState(null);
  const [reInitiateSnackBar, setReInitiateSnackbar] = useState(false);
  const [snackBarMessage, setSnackBarMessage] = useState({
    title: "",
    type: "",
  });
  const [assignee, setAssignee] = useState([]);
  const [createdActivity, setCreatedActivity] = useState(null);
  const [tagAttachments, setTagAttachments] = useState([]);
  const [attachmentCategories, setAttachmentCategories] = useState([]);
  const [statuses, setStatuses] = useState([]);
  const [remarkCategories, setRemarkCategories] = useState([]);

  useEffect(() => {
    getAssigneeDetails();
    getActivities(id);
    getAttachmentCategories();
    getStatusandRemarkCategories();
  }, []);

  const handleOpenEditDialog = async (activity) => {
    let activityHistoryResponse = await getActivityHistoryByID(
      activity.activityId
    );
    let data = await getSpecificRemarkCategoryForActivity(
      activity.activityOrder,
      activity.name,
      partner
    );
    setRemarkCategories(data.remarkCategory.data);
    setActivityHistory(activityHistoryResponse);
    setSelectedSubActivity(activity);
    setInitialSelectedSubActivity(activity);
    setOpenEditDialog(true);
  };

  const handleOpenViewModal = async (activity) => {
    let activityHistoryResponse = await getActivityHistoryByID(
      activity.activityId
    );
    setActivityHistory(activityHistoryResponse);
    setSelectedSubActivity(activity);
    setIsViewModalOpen(true);
  };

  const handleReInitiateActivity = (activity) => {
    setSelectedReInitiatedItem(activity);
    setReInitiateModal(true);
  };

  const handleReInitiateActivityClose = () => {
    setReInitiateModal(false);
  };

  function convertToISTDateOnly(dateString) {
    if (dateString == null) {
      return "-";
    }
    const date = new Date(dateString);
    const options = {
      timeZone: "Asia/Kolkata",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    };

    const formatter = new Intl.DateTimeFormat("en-IN", options);
    const formattedDateParts = formatter.formatToParts(date);
    const year = formattedDateParts.find((part) => part.type === "year").value;
    const month = formattedDateParts.find(
      (part) => part.type === "month"
    ).value;
    const day = formattedDateParts.find((part) => part.type === "day").value;

    return `${year}-${month}-${day}`;
  }
  const addActivitiesForSiteId = async (id) => {
    try {
      const res = await createActivitiesBySiteId(id, projectId);
      if (res) {
        await getActivities(id);
        await get_Site(id);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getActivities = async (siteId) => {
    try {
      setIsLoading(true);
      const res = await getActivitiesBySiteId(siteId, projectId);
      const stageMaster = await getStageMaster();
      let temp = [];
      for (let i = 0; i < res.length; i++) {
        const stageLookup = stageMaster.reduce((acc, stage) => {
          acc[stage.StageCode] = stage.StageName;
          return acc;
        }, {});
        let startDate = res[i].ActualStartDate
          ? new Date(res[i].ActualStartDate)
          : null;
        if (startDate && res[i].sla) {
          startDate.setDate(startDate.getDate() + res[i].sla);
        }
        let obj = {
          activityId: res[i].ActivityID,
          activityOrder: res[i].ActivityOrder,
          stageCode: res[i].StageCode,
          stageName: stageLookup[res[i].StageCode],
          id: i + 1,
          type: stageLookup[res[i].StageCode] || null,
          name: res[i].ActivityName,
          modalTitle: `${stageLookup[res[i].StageCode]} -  ${
            res[i].ActivityName
          }`,
          startDate: convertToISTDateOnly(res[i].ActualStartDate) || "",
          endDate: convertToISTDateOnly(res[i].ActualEndDate) || "",
          expectedEndDate: startDate ? convertToISTDateOnly(startDate) : "",
          status: res[i].Status == null ? "Not Started" : res[i].Status,
          assignedTo: res[i].AssignedTo || "-",
          actionBtn: "",
          remarkCategory: "",
          remarkStatement: "",
          sla: res[i].sla,
          can_start: res[i].can_start,
          attachmentRequired: res[i].attachmentRequired,
        };
        temp.push(obj);
      }
      setActivities(temp);
    } catch (error) {
      console.log("error", error);
    } finally {
      setIsLoading(false);
    }

    // setAssets(temp);
  };

  useEffect(() => {
    if (selectedSubActivity) {
      const startDate =
        selectedSubActivity?.startDate !== "-"
          ? selectedSubActivity?.startDate
          : getCurrentDate();
      const slaDays = selectedSubActivity?.sla || 0;
      let expectedEndDate = selectedSubActivity.expectedEndDate || "";
      if (startDate && slaDays) {
        const date = new Date(startDate);
        const calculatedEndDate = new Date(
          date.getTime() + slaDays * 24 * 60 * 60 * 1000
        );
        expectedEndDate = convertToISTDateOnly(calculatedEndDate.toISOString());
      }
      setFormValues({
        modalTitle: selectedSubActivity?.modalTitle,
        startDate: startDate,
        expectedEndDate: expectedEndDate,
        actualEndDate: selectedSubActivity.endDate || "",
        assignedTo: selectedSubActivity.assignedTo || "",
        attachments: selectedSubActivity.attachments || [],
        status:
          selectedSubActivity.status === "Not Started"
            ? "Started"
            : selectedSubActivity.status,
        // remarkCategory: selectedSubActivity.remarkCategory,
        // remarkStatement: selectedSubActivity.remarkStatement,
      });
    } else {
      setFormValues({
        modalTitle: "",
        startDate: "",
        attachments: [],
        expectedEndDate: "",
        actualEndDate: "",
        assignedTo: "",
        status: "Started",
        tenderStatus: 0,
        remarkCategory: "",
        remarkStatement: "",
      });
    }
  }, [selectedSubActivity]);

  const handleCloseEditDialog = () => {
    setOpenEditDialog(false);
    setEditedActivity(null);
    setSelectedSubActivity(null);
  };
  const handleCloseViewModal = () => {
    setIsViewModalOpen(false);
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
    if (name === "startDate") {
      const date = new Date(value);
      const slaDays = selectedSubActivity?.sla || 0;
      const expectedEndDate = new Date(
        date.getTime() + slaDays * 24 * 60 * 60 * 1000
      );
      const formattedExpectedEndDate = convertToISTDateOnly(
        expectedEndDate.toISOString()
      );
      setFormValues((prevValues) => ({
        ...prevValues,
        expectedEndDate: formattedExpectedEndDate,
      }));
    }
  };

  const handleSubmit = async () => {
    await UpdateActivityModal();
    setTrigger((prev) => !prev);
    await get_Site(id);
    setFormValues({
      modalTitle: "",
      startDate: "",
      attachments: [],
      expectedEndDate: "",
      actualEndDate: "",
      assignedTo: "",
      status: "Started",
      remarkCategory: "",
      remarkStatement: "",
    });
    await getActivities(id);
    setSelectedSubActivity(null);
    setOpenEditDialog(false);
  };

  const shouldShowStartButton = (index) => {
    if (index === 0) return true;
    return activities[index - 1].status === "Done";
  };

  const UpdateActivityModal = async () => {
    try {
      let changedData = getChangedData(formValues, selectedSubActivity);
      let currentStatus = selectedSubActivity.status;
      let activityType = selectedSubActivity.type;
      let changeDataObj = { changedData, currentStatus, activityType };

      const body = {
        activityData: {
          ActualStartDate: convertToISOFormat(new Date(formValues.startDate)),
          Status: formValues.status,
          AssignedTo: formValues.assignedTo,
          SiteID: id,
          TenderStatus: formValues.tenderStatus,
          StageName: selectedSubActivity.stageName,
          ActivityName: selectedSubActivity.name,
        },
        remarkData: {
          ActivityID: selectedSubActivity.activityId,
          RemarkCategory: formValues.remarkCategory,
          Remarks: formValues.remarkStatement,
          Action: JSON.stringify(changeDataObj),
        },
      };
      if (formValues.status == "Done") {
        body.activityData.ActualEndDate = convertToISOFormat(
          new Date(formValues.actualEndDate)
        );
      }
      if (formValues.expectedEndDate && formValues.expectedEndDate != "-") {
        body.activityData.ExpectedEndDate = convertToISOFormat(
          new Date(formValues.expectedEndDate)
        );
      }
      if (formValues.attachments) {
        body.remarkData.AttachmentLink = JSON.stringify(formValues.attachments);
      }
      let updateActivityResponse = await updateActivityDetails(
        selectedSubActivity.activityId,
        body
      );
      const tagsArray = [
        {
          key: "activity_name",
          value: selectedSubActivity.stageName,
        },
        {
          key: "remark_id",
          value: updateActivityResponse.siteActivityRemark.RemarkID,
        },
      ];
      const updatedFilesArray = tagAttachments?.map((file) => ({
        ...file,
        tags: [...file.tags, ...tagsArray],
      }));

      const tagBody = {
        tagAttachments: updatedFilesArray,
      };

      if (updateActivityResponse.message == "Activity updated") {
        const tagResponse = await tagUploadedAttachment(tagBody, projectCode);
      }
    } catch (e) {
      setReInitiateSnackbar(true);
      setSnackBarMessage({
        title: "An Error occur in Activity modal",
        type: "error",
      });
    } finally {
    }
  };

  const isSubmitDisabled = () => {
    return (
      !formValues.remarkCategory ||
      formValues.remarkCategory.trim() === "" ||
      !formValues.remarkStatement ||
      formValues.remarkStatement.trim() === ""
    );
  };

  const reInitializationActivity = async (activity) => {
    try {
      const body = {
        SiteID: id,
        StageCode: activity.stageCode,
        ActivityName: activity.name,
        ActivityOrder: activity.activityOrder,
        sla: activity.sla,
      };
      let reInitiateResponse = await reInitiateActivity(body);
      console.log(
        "reInitiateResponse------------------------>",
        reInitiateResponse
      );
      if (reInitiateResponse.status == 201) {
        setReInitiateSnackbar(true);
        setSnackBarMessage({
          title: `${activity.name} re-initiated successfully!`,
          type: "success",
        });
        handleReInitiateActivityClose();
        setTimeout(async () => {
          await get_Site(id);
          await getActivities(id);
        }, 1000);
      }
    } catch (e) {
      setSnackBarMessage({
        title: `${activity.name} already re-initiated`,
        type: "error",
      });
      handleReInitiateActivityClose();
      setReInitiateSnackbar(true);
    }
  };

  const handleCloseSnackBar = () => {
    setReInitiateSnackbar(false);
  };

  const getAssigneeDetails = async () => {
    try {
      let assigneeResponse = await getAssignee("SIL");
      if (assigneeResponse.length) {
        setAssignee(assigneeResponse);
      }
    } catch (e) {
      console.log("error in getAssigneeDetails", e);
    } finally {
    }
  };

  const showDelayIcon = (expectedEndDate, actualEndDate, status) => {
    if (status == "Done") {
      if (new Date(expectedEndDate) < new Date(actualEndDate)) {
        const timeDiff = Math.abs(
          new Date(expectedEndDate) - new Date(actualEndDate)
        );
        const daysDelayed = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
        if (daysDelayed > 0) {
          return (
            <Tooltip title={`This activity is delayed by ${daysDelayed} days`}>
              <RunningWithErrorsIcon color="error" />
            </Tooltip>
          );
        }
      }
    } else {
      if (new Date(expectedEndDate) < new Date()) {
        const timeDiff = Math.abs(new Date(expectedEndDate) - new Date());
        const daysDelayed = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
        if (daysDelayed > 0) {
          return (
            <Tooltip title={`This activity is delayed by ${daysDelayed} days`}>
              <RunningWithErrorsIcon color="error" />
            </Tooltip>
          );
        }
      }
    }
  };

  const getAttachmentCategories = async () => {
    try {
      let attachmentCategoriesRes = await getAllAttachmentCategory(partner);
      if (attachmentCategoriesRes.length) {
        setAttachmentCategories(attachmentCategoriesRes);
      }
    } catch (e) {
      setSnackBarMessage({ title: e.response.message, type: "error" });
      setReInitiateSnackbar(true);
    } finally {
    }
  };

  const getStatusandRemarkCategories = async () => {
    try {
      let res = await getAllStatusesAndRemarks(partner);
      setStatuses(res.status);
    } catch (e) {
      setSnackBarMessage({ title: e.response.message, type: "error" });
      setReInitiateSnackbar(true);
    } finally {
    }
  };

  const downloadImage = async () => {
    try {
      const downloadResponse = await downloadAttachment(projectCode);

      const url = window.URL.createObjectURL(new Blob([downloadResponse]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "image.png");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error downloading the image:", error);
    }
  };

  const columns = useMemo(
    () => [
      {
        accessorKey: "id",
        header: "ID",
        size: 10,
      },
      {
        accessorKey: "type",
        header: "Activity Type",
        size: 10,
      },
      {
        accessorKey: "name",
        header: "Activity Name",
        size: 15,
      },
      {
        accessorKey: "startDate",
        header: "Start Date",
        size: 15,
      },
      {
        accessorKey: "expectedEndDate",
        header: "Expected End Date",
        accessorFn: (row) => (
          <Box display="flex" alignItems="center">
            <span>{row.expectedEndDate}</span>
            <span style={{ marginLeft: 8 }}>
              {showDelayIcon(row.expectedEndDate, row.endDate, row.status)}
            </span>
          </Box>
        ),
        size: 15,
        id: "expectedEndDate",
      },
      {
        accessorKey: "endDate",
        header: "Actual End Date",
        size: 15,
      },
      {
        accessorKey: "status",
        header: "Status",
        Cell: ({ cell }) => (
          <Box
            display={"flex"}
            alignItems={"center"}
            justifyContent={"space-evenly"}
          >
            <Chip
              label={cell.getValue()}
              color={getStatusColor(cell.getValue())}
            ></Chip>
          </Box>
        ),
        size: 10,
      },
      {
        accessorKey: "assignedTo",
        header: "Assigned To",
        size: 15,
      },
      {
        header: "Action",
        size: 100,
        Cell: ({ row }) => {
          const { status } = row.original;

          return (
            <Box display={"flex"} justifyContent={"space-between"}>
              {status === "Done" ? (
                <>
                  <VisibilityIcon
                    sx={{ color: "green", cursor: "pointer" }}
                    onClick={() => handleOpenViewModal(row.original)}
                  />
                  <AutoModeIcon
                    sx={{ color: "blue", cursor: "pointer" }}
                    onClick={() => handleReInitiateActivity(row.original)}
                  />
                </>
              ) : status === "In Progress" || status === "Started" ? (
                <>
                  <VisibilityIcon
                    sx={{ color: "green", cursor: "pointer" }}
                    onClick={() => handleOpenViewModal(row.original)}
                  />
                  <EditIcon
                    sx={{ color: "#b41660", cursor: "pointer" }}
                    onClick={() => handleOpenEditDialog(row.original)}
                  />
                </>
              ) : row.original.can_start ? (
                <Button
                  variant="contained"
                  sx={{ backgroundColor: "#b41660" }}
                  onClick={() => handleOpenEditDialog(row.original)}
                >
                  Start
                </Button>
              ) : null}
            </Box>
          );
        },
      },
    ],
    [
      handleOpenViewModal,
      handleOpenEditDialog,
      handleReInitiateActivity,
      shouldShowStartButton,
      getStatusColor,
    ]
  );

  return (
    <>
      {isLoading ? (
        <CircularProgress />
      ) : (
        // <ThemeProvider theme={theme}>
        <div style={{ width: "100%", margin: "auto" }}>
          {activities.length > 0 && (
            <DynamicTable columns={columns} data={activities} />
          )}

          {/* Edit Dialog */}
          <ActivityMenuModal
            modalOpen={openEditDialog}
            handleCloseModal={handleCloseEditDialog}
            formValues={formValues}
            handleChange={handleChange}
            handleSubmit={handleSubmit}
            setFormValues={setFormValues}
            auditData={auditData}
            selectedSubActivity={selectedSubActivity}
            errors={errors}
            setErrors={setErrors}
            isSubmitDisabled={isSubmitDisabled}
            activityHistory={activityHistory}
            assignee={assignee}
            projectCode={projectCode}
            setReInitiateSnackbar={setReInitiateSnackbar}
            handleCloseSnackBar={handleCloseSnackBar}
            setSnackBarMessage={setSnackBarMessage}
            createdActivity={createdActivity}
            setTagAttachments={setTagAttachments}
            tagAttachments={tagAttachments}
            attachmentCategories={attachmentCategories}
            statuses={statuses}
            remarkCategories={remarkCategories}
            downloadImage={downloadImage}
          />
          <ViewActivityMenuModal
            modalOpen={isViewModalOpen}
            handleCloseModal={handleCloseViewModal}
            formValues={formValues}
            auditData={auditData}
            activityHistory={activityHistory}
          />

          <AlertModal
            alertDialogOpen={reInitiateModal}
            handleCloseAlertDialog={handleReInitiateActivityClose}
            title="Confirmation Required"
            desc={`${selectedReInitiatedItem?.name} has already been completed. Would you like to re-initiate it?`}
            cancelBtnName="No"
            confirmBtnName="Yes"
            reInitializationActivity={reInitializationActivity}
            selectedReInitiatedItem={selectedReInitiatedItem}
          />

          <SnackBars
            open={reInitiateSnackBar}
            setOpen={setReInitiateSnackbar}
            handleClose={handleCloseSnackBar}
            title={snackBarMessage.title}
            type={snackBarMessage.type}
          />

          {activities.length === 0 && (
            <Box sx={{ marginTop: 2 }}>
              <Typography my={2} fontSize={20}>
                Activities aren't initiated please click to start activity.
              </Typography>
              <Button
                variant="contained"
                onClick={() => addActivitiesForSiteId(id)}
                sx={{ backgroundColor: "#b41660" }}
              >
                Initiate Activities
              </Button>
            </Box>
          )}
        </div>
        // </ThemeProvider>
      )}
    </>
  );
};

export default ActivityTable;
